import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Plus, Upload, BarChart3, Building, FileText, Search, Settings, Users, Package, Sun } from 'lucide-react';
import { getAuthData } from '../../utils/auth';

export const AdminHome: React.FC = () => {
  const authData = getAuthData();
  console.log("ADMIN HOME AUTH DATA", authData);

  const cards = [
    {
      title: 'Create New Panel',
      description: 'Add a new solar panel with detailed specifications',
      icon: Plus,
      link: '/admin/create',
      color: 'bg-blue-500'
    },
    {
      title: 'Manage Panels',
      description: 'View, edit, and manage all solar panels in the database',
      icon: Settings,
      link: '/admin/panels',
      color: 'bg-teal-500'
    },
    {
      title: 'Upload PDF',
      description: 'Extract panel data from PDF documents',
      icon: Upload,
      link: '/admin/upload',
      color: 'bg-green-500'
    },
    {
      title: 'Search Analytics',
      description: 'View search statistics and logs',
      icon: BarChart3,
      link: '/admin/analytics',
      color: 'bg-purple-500'
    },
    {
      title: 'Manage Suppliers',
      description: 'Add and manage supplier accounts',
      icon: Building,
      link: '/admin/suppliers',
      color: 'bg-orange-500'
    },
    {
      title: 'Supplier Requests',
      description: 'Review and approve supplier account requests',
      icon: Users,
      link: '/admin/supplier-requests',
      color: 'bg-teal-500'
    },
    {
      title: 'Panel Requests',
      description: 'Review and approve panel addition requests',
      icon: FileText,
      link: '/admin/requests',
      color: 'bg-red-500'
    },
    {
      title: 'Manage Inventory',
      description: 'View and manage inventory across all suppliers',
      icon: Package,
      link: '/admin/inventory',
      color: 'bg-yellow-500'
    },
    {
      title: 'Search Logs',
      description: 'View detailed search activity logs',
      icon: Search,
      link: '/admin/search-logs',
      color: 'bg-indigo-500'
    },
    {
      title: 'Solar Monitoring',
      description: 'Monitor solar panel output and manage alerts',
      icon: Sun,
      link: '/admin/solar-monitoring',
      color: 'bg-yellow-600'
    }
  ];

  return (
    <div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="mb-8"
      >
        <h1 className="text-3xl font-bold text-gray-900">
          Welcome back, {authData?.user.full_name}
        </h1>
        <p className="text-gray-600 mt-2">{authData?.user.company}</p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {cards.map((card, index) => (
          <motion.div
            key={card.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Link to={card.link}>
              <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 cursor-pointer group">
                <div className={`${card.color} w-12 h-12 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <card.icon className="h-6 w-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{card.title}</h3>
                <p className="text-gray-600">{card.description}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </div>
  );
};